import { render } from "./ProfileOverview.vue?vue&type=template&id=5c212ba7&scoped=true"
import script from "./ProfileOverview.vue?vue&type=script&lang=js"
export * from "./ProfileOverview.vue?vue&type=script&lang=js"

import "./ProfileOverview.vue?vue&type=style&index=0&id=5c212ba7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c212ba7"]])

export default __exports__